<template>
  <b-button
    v-b-tooltip.hover
    variant="outline-primary"
    :title="tooltipTitle"
    @click="toggle"
  >
    <i class="bi bi-transparency" />
  </b-button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SeeThrough',

    data() {
        return {
            refreshKey: 0,
        }
    },

    computed: {
        ...mapGetters('layout', [
            'target',
        ]),

        tooltipTitle() {
            this.refreshKey;
            return this.target?._isSeeThrough ? 'Restore' : 'See-Through';
        },
    },

    methods: {
        toggle() {
            if (!this.target) {
                console.warn('No target selected');
                return;
            }

            const isSeeThrough = this.target._isSeeThrough;

            if (!isSeeThrough) {
                this.target._originalOpacity = this.target.opacity !== undefined ? this.target.opacity : 1;
                this.target._isSeeThrough = true;

                this.target.set({
                    opacity: 0.4,
                    evented: false,
                    selectable: false,
                });
            } else {
                const restoredOpacity = this.target._originalOpacity !== undefined ? this.target._originalOpacity : 1;

                this.target.set({
                    opacity: restoredOpacity,
                    evented: true,
                    selectable: true,
                });

                this.target._isSeeThrough = false;
                this.target._originalOpacity = undefined;
            }

            this.target.canvas.fire('see-through:changed', this.target);
            this.target.canvas.requestRenderAll();

            this.refreshKey++;
        },
    },
}
</script>

<style scoped lang="scss"></style>
